/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DemandeFormationGridDto } from './DemandeFormationGridDto';
import {
    DemandeFormationGridDtoFromJSON,
    DemandeFormationGridDtoFromJSONTyped,
    DemandeFormationGridDtoToJSON,
} from './DemandeFormationGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface DemandeFormationGridDtoPaginatedResults
 */
export interface DemandeFormationGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof DemandeFormationGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<DemandeFormationGridDto>}
     * @memberof DemandeFormationGridDtoPaginatedResults
     */
    results?: Array<DemandeFormationGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof DemandeFormationGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the DemandeFormationGridDtoPaginatedResults interface.
 */
export function instanceOfDemandeFormationGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DemandeFormationGridDtoPaginatedResultsFromJSON(json: any): DemandeFormationGridDtoPaginatedResults {
    return DemandeFormationGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function DemandeFormationGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DemandeFormationGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(DemandeFormationGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function DemandeFormationGridDtoPaginatedResultsToJSON(value?: DemandeFormationGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(DemandeFormationGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

